<template>
  <div class="grey lighten-5 fill-height">
    <v-container class="py-0">
      <v-row>
        <v-col
          :cols="$store.state.mobile ? 12 : 8"
          :offset="$store.state.mobile ? 0 : 2"
          :class="$store.state.mobile ? 'pt-0' : ''"
        >
          <v-row align="center">
            <v-col cols="auto">
              <router-link to="/">
                <v-img
                  :src="this.$store.state.webConfig.logo"
                  :width="$store.state.mobile ? 100 : 177"
                  :height="$store.state.mobile ? 36 : 64"
                />
              </router-link>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
              <v-stepper
                value="2"
                class="grey lighten-5"
              >
                <v-stepper-header>
                  <v-stepper-step
                    step="1"
                    complete
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      التسوق
                    </template>
                    <template v-else>
                      Shopping
                    </template>
                  </v-stepper-step>
                  <v-divider />
                  <v-stepper-step step="2">
                    <template v-if="$store.getters.languageGetter === '1'">
                      مكان الامر
                    </template>
                    <template v-else>
                      Place order
                    </template>
                  </v-stepper-step>
                  <v-divider />
                  <v-stepper-step step="3">
                    <template v-if="$store.getters.languageGetter === '1'">
                      مكتمل
                    </template>
                    <template v-else>
                      Completed
                    </template>
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
          </v-row>
          <v-card
            :loading="loading"
            outlined
            tile
            :style="noAddress ? 'border-width:4px;border-color:#f51414' : ''"
          >
            <v-card-title class="font-medium">
              <template v-if="$store.getters.languageGetter === '1'">
                عنوان الشحن
              </template>
              <template v-else>
                Shipping Address
              </template>
              <v-btn
                v-if="addressListGetter.length"
                text
                class="ms-auto font-medium black--text"
                @click="show = true"
              >
                <v-icon
                  size="24"
                  left
                  color="#f51414"
                >
                  mdi-plus
                </v-icon>
                <template v-if="$store.getters.languageGetter === '1'">
                  أضف عنوانا جديدا
                </template>
                <template v-else>
                  Add a New Address
                </template>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-alert
                dense
                type="info"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  ملاحظة الطلب: يجب أن يكون ملء عنوان التسليم متسقًا مع البلد المحدد ، وإلا فلن يتم شحنه ، شكرًا لك
                </template>
                <template v-else>
                  Note when placing an order: fill in the delivery address must be consistent with the selected country, otherwise it will not be shipped, thank you
                </template>
              </v-alert>
              <div
                v-if="!addressListGetter.length"
                class="text-center"
              >
                <v-btn
                  text
                  class="ms-auto font-medium black--text"
                  @click="show = true"
                >
                  <v-icon
                    size="24"
                    left
                    color="#f51414"
                  >
                    mdi-plus
                  </v-icon>
                  <template v-if="$store.getters.languageGetter === '1'">
                    أضف عنوانا جديدا
                  </template>
                  <template v-else>
                    Add a New Address
                  </template>
                </v-btn>
              </div>
              <v-radio-group
                v-model="activeIndex"
                hide-details
                class="mt-0"
              >
                <v-card
                  v-for="(address, i) in addressListGetter"
                  :key="address.id"
                  class="pa-3 mb-3"
                  :class="i === activeIndex ? 'green lighten-5' : ''"
                  :style="i === activeIndex ? 'border-color:#43a047 !important' : ''"
                  outlined
                >
                  <v-radio
                    color="green darken-1"
                    :disabled="address.countryId !== $store.getters.countryGetter.id"
                    @click="activeIndex = i;showLength = i + 1"
                  >
                    <template v-slot:label>
                      <div style="width:100%">
                        <div class="text-h5 font-medium black--text d-flex align-center">
                          {{ address.contacter }}
                          <v-chip
                            v-if="address.isDefault === '1'"
                            small
                            color="#ff9a00"
                            dark
                            class="ms-2"
                          >
                            <template v-if="$store.getters.languageGetter === '1'">
                              تقصير
                            </template>
                            <template v-else>
                              Default
                            </template>
                          </v-chip>
                          <span class="ms-auto"><v-icon
                            small
                            class="me-1"
                          >mdi-cellphone</v-icon>{{ address.mobile }}</span>
                        </div>
                        <div class="d-flex align-center">
                          {{ `${$store.getters.countryNameGetter(address.countryId)}, ${address.address}, ${address.city}, ${address.province}` }}
                          <v-btn
                            small
                            icon
                            class="ms-auto"
                            @click="editAddress(address)"
                          >
                            <v-icon size="18">
                              mdi-square-edit-outline
                            </v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </template>
                  </v-radio>
                </v-card>
              </v-radio-group>
            </v-card-text>
          </v-card>
          <v-card
            outlined
            tile
            class="mt-4"
          >
            <v-card-title class="font-medium">
              <template v-if="$store.getters.languageGetter === '1'">
                طريقة الدفع او السداد
              </template>
              <template v-else>
                Payment method
              </template>
            </v-card-title>
            <v-divider />
            <v-card-text class="pb-0">
              <v-radio-group
                v-model="paymentMethod"
                class="mt-0 "
              >
                <v-radio
                  value="1"
                  color="green darken-1"
                >
                  <template
                    v-slot:label
                  >
                    <div>
                      <v-img
                        :src="require('@/assets/paypal-lg.png')"
                        width="100"
                        class="mb-1"
                      />
                    </div>
                  </template>
                </v-radio>
                <v-radio
                  value="2"
                  color="green darken-1"
                >
                  <template
                    v-slot:label
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      الدفع دون اتصال ، يرجى الاتصال
                    </template>
                    <template v-else>
                      Pay offline, please contact
                    </template> {{ $store.state.webConfig.mobile }}
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
          <v-card
            outlined
            tile
            class="mt-4"
          >
            <v-card-title class="font-medium">
              <template v-if="$store.getters.languageGetter === '1'">
                قائمة المنتجات
              </template>
              <template v-else>
                Products
              </template>
            </v-card-title>
            <v-divider />
            <div v-if="$store.state.mobile">
              <div
                v-for="(item) in detail"
                :key="item.id"
              >
                <v-container>
                  <v-row>
                    <v-col
                      cols="4"
                    >
                      <router-link :to="{name: 'GoodsDetail', params: {id: item.goodId}}">
                        <v-img
                          :src="item.specImage ? item.specImage : item.image"
                          aspect-ratio="1"
                          contain
                          class="grey lighten-5"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey"
                              />
                            </v-row>
                          </template>
                        </v-img>
                      </router-link>
                    </v-col>
                    <v-col>
                      <div class="mb-2 line-break line-height-sm black--text">
                        {{ $store.getters.languageGetter === '1' ? item.goodName : item.goodNameEn }}
                      </div>
                      <div class="grey--text">
                        {{ item.goodNo }}
                      </div>
                      <div class="grey--text">
                        {{ $store.getters.languageGetter === '1' ? item.goodDetailName : item.goodDetailNameEn }}
                      </div>
                      <div class="d-flex align-center justify-space-between">
                        <div class="text-h5 font-medium black--text d-flex align-center justify-center">
                          <span
                            class="text-h4 me-2"
                          >{{ $store.getters.countryGetter.currency }}{{ (priceRate(item) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
                          <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(item).toFixed(2) }}</span>
                        </div>
                        x{{ item.buNumber }}
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider />
              </div>
              <div class="pa-4">
                <div>
                  <v-textarea
                    v-model="memo"
                    :label="$store.getters.languageGetter === '1' ? 'معلومات تصريحات' : 'Remark'"
                    outlined
                    dense
                    rows="5"
                  />
                  <img-upload-input
                    :image="annex"
                    @update:src="annex = $event"
                    @update:delete="annex = ''"
                  />
                </div>
                <div class="text-h3 font-medium mb-2 d-flex justify-space-between">
                  <template v-if="$store.getters.languageGetter === '1'">
                    السعر الإجمالي للبضائع:
                  </template>
                  <template v-else>
                    Grand Total:
                  </template> {{ $store.getters.countryGetter.currency }}{{ totalAmount }}
                </div>
                <div>
                  <v-btn
                    :loading="submitting"
                    color="#f16056"
                    depressed
                    x-large
                    dark
                    block
                    @click="submitForm"
                  >
                    Place Order
                  </v-btn>
                </div>
              </div>
            </div>
            <v-card-text v-else>
              <v-data-table
                :headers="headers"
                :items="detail"
                item-key="goodDetailId"
                class="data-table-with-select"
                no-data-text="Nothing here"
                loading-text="Loading..."
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.goods="{item}">
                  <div
                    class="py-3 d-flex"
                    style="max-width:350px"
                  >
                    <div>
                      <router-link :to="{name: 'GoodsDetail', params: {id: item.goodId}}">
                        <v-img
                          :src="item.specImage ? item.specImage : item.image"
                          width="80"
                          height="80"
                          class="grey lighten-5"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey"
                              />
                            </v-row>
                          </template>
                        </v-img>
                      </router-link>
                    </div>
                    <div class="ps-3">
                      <div class="mb-2 line-break line-height-sm black--text">
                        {{ $store.getters.languageGetter === '1' ? item.goodName : item.goodNameEn }}
                      </div>
                      <div class="grey--text">
                        {{ item.goodNo }}
                      </div>
                      <div class="grey--text">
                        {{ $store.getters.languageGetter === '1' ? item.goodDetailName : item.goodDetailNameEn }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:item.price="{item}">
                  <div class="d-flex align-center justify-center">
                    <span
                      class="text-h4 me-2"
                    >{{ $store.getters.countryGetter.currency }}{{ (priceRate(item) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
                    <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(item).toFixed(2) }}</span>
                  </div>
                </template>
                <template v-slot:item.summary="{item}">
                  {{ $store.getters.countryGetter.currency }}{{ +(priceRate(item) * $store.getters.rebateGetter / 100 * +item.goodNumber).toFixed(2) }}
                </template>
                <template v-slot:footer>
                  <v-divider />
                  <v-row>
                    <v-col cols="8">
                      <v-textarea
                        v-model="memo"
                        :label="$store.getters.languageGetter === '1' ? 'ملاحظة' : 'Remark'"
                        outlined
                        dense
                        rows="5"
                      />
                      <img-upload-input
                        :image="annex"
                        @update:src="annex = $event"
                        @update:delete="annex = ''"
                      />
                    </v-col>
                    <v-col
                      cols="4"
                      class="text-right"
                    >
                      <div class="text-h5 font-medium mb-2">
                        <span><template v-if="$store.getters.languageGetter === '1'">السعر الإجمالي للبضائع:</template>
                          <template v-else>
                            Grand Total:
                          </template></span> {{ $store.getters.countryGetter.currency }}{{ totalAmount }}
                      </div>
                      <div>
                        <v-btn
                          :loading="submitting"
                          color="#f16056"
                          depressed
                          large
                          dark
                          @click="submitForm"
                        >
                          <template v-if="$store.getters.languageGetter === '1'">
                            مكان الامر
                          </template>
                          <template v-else>
                            Place Order
                          </template>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="show"
      max-width="650"
    >
      <Address
        :id="id"
        :item="item"
        :header="true"
        @update:added="noAddress = false"
        @update:close="show = false;id = ''; item = {}"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Address from '@/components/Address.vue';
import ImgUploadInput from '@/components/ImgUploadInput.vue';

export default {
  name: 'PlaceOrder',
  components: {
    Address,
    ImgUploadInput,
  },
  props: {
    goods: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      paymentMethod: '1',
      loading: false,
      toggle: false,
      noAddress: false,
      activeIndex: 0,
      showLength: 1,
      show: false,
      item: {},
      id: '',
      detail: [],
      memo: '',
      annex: '',
      submitting: false,
    };
  },
  computed: {
    ...mapGetters('center', ['addressListGetter']),
    headers() {
      return [
        {
          text: this.$store.getters.languageGetter === '1' ? 'بند' : 'Item',
          align: 'start',
          sortable: false,
          value: 'goods',
          class: 'text-h6 black--text grey lighten-4',
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'سعر' : 'Price',
          value: 'price',
          sortable: true,
          class: 'text-h6 black--text grey lighten-4',
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'كمية' : 'Quantity',
          value: 'goodNumber',
          class: 'text-h6 black--text grey lighten-4',
          sortable: true,
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'كمية' : 'Amount',
          value: 'summary',
          class: 'text-h6 black--text grey lighten-4',
          sortable: false,
        },
      ];
    },
    defaultIndex() {
      return this.addressListGetter.findIndex((item) => item.countryId === this.$store.getters.countryGetter.id);
    },
    totalAmount() {
      return this.detail.reduce((acc, item) => acc + +item.goodNumber * this.priceRate(item) * (this.$store.getters.rebateGetter / 100), 0).toFixed(2);
    },
    selectedAddress() {
      return this.activeIndex === -1 ? null : this.addressListGetter[this.activeIndex];
    },
    params() {
      return {
        freeAmount: '',
        isInvoice: '0',
        invoiceId: '',
        annex: this.annex,
        invoiceTitle: '',
        taxpayer: '',
        payType: this.paymentMethod,
        countryId: this.$store.getters.countryGetter.id,
        countryName: this.$store.getters.countryGetter.dnames,
        tel: `+(${this.selectedAddress.callingCodes}) ${this.selectedAddress.mobile}`,
        bank: '',
        cardNo: '',
        amountPrice: this.totalAmount,
        deliveryTime: '',
        memo: this.memo,
        invoiceTax: 0,
        detail: this.detail,
        addrId: this.selectedAddress.id,
        addr: `${this.selectedAddress.address}, ${this.selectedAddress.city}, ${this.selectedAddress.province}, ${this.selectedAddress.countryName}`,
        openId: this.$store.state.user.supplierOpenId,
        account: this.$store.state.user.account,
        mobile: this.$store.state.user.mobile,
      };
    },
  },
  created() {
    this.loadPageData();
  },
  methods: {
    ...mapActions('center', ['getAddressListAsync']),
    ...mapActions('cart', ['placeOrderAsync']),
    loadPageData() {
      this.loading = true;
      this.detail = JSON.parse(this.goods);
      this.getAddressListAsync({ buyerId: this.$store.state.user.sellerId }).then(() => {
        this.activeIndex = this.defaultIndex;
      }).finally(() => {
        this.loading = false;
      });
    },
    editAddress(item) {
      this.item = item;
      this.id = item.id;
      this.show = true;
    },
    submitForm() {
      if (!this.selectedAddress) {
        this.noAddress = true;
        return;
      }
      this.submitting = true;
      this.placeOrderAsync(this.params).then((res) => {
        if (this.paymentMethod === '1') {
          this.$router.replace({ name: 'PayNow', params: { id: res.id } });
        } else {
          this.$router.replace({
            name: 'UserOrderList',
          });
        }
      }).finally(() => {
        this.submitting = false;
      });
    },
    priceRate(item) {
      return (+item.countryPrice[this.$store.getters.countryGetter.id] * +this.$store.getters.countryGetter.rate);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
